<template>
    <PopForm :state="state" width="992px" body-max-height="580px">
        <template slot="title">
            <span v-if="cardInfo.count_type === '1'">[次卡]</span>
            <span v-else-if="cardInfo.count_type === '2'">[时卡]</span>
            <span v-else-if="cardInfo.count_type === '3'">[通卡]</span>
            {{cardInfo.title}}权益
            <span class="fr" @click="close"><i class="el-icon-close"></i></span>
        </template>

        <div class="form-body">
            <div class="text-desc flex">
                <span class="flex-1">购买人：{{cardInfo.mobile}}</span>
                <span class="flex-1">购买时间：{{cardInfo.create_datetime}}</span>
                <span class="flex-1">卡号：{{cardInfo.card_no}}</span>
            </div>
            <div class="product-list">
                <el-row class="ht">
                    <el-col :span="6">包含项目</el-col>
                    <el-col :span="6" class="tc">单价</el-col>
                    <el-col :span="6" class="tc">次数</el-col>
                    <el-col :span="6" class="tr">有效时间</el-col>
                </el-row>
                <el-row class="list-line" v-for="(val, key) in listData" :key="key">
                    <el-col :span="6">
                        {{val.pro_title}}
                        <el-tag type="danger" effect="dark" size="mini" v-if="val.tag">{{val.tag}}</el-tag>
                    </el-col>
                    <el-col :span="6" class="tc">{{val.price ? "¥ "+val.price : "&nbsp;"}}</el-col>
                    <el-col :span="6" class="tc">
                        {{val.num > 0 ? val.num : '不限'}}次
                    </el-col>
                    <el-col :span="6" class="tr">
                        <span v-if="cardInfo.valid_day > 0">{{cardInfo.valid_day}}天</span>
                        <span v-else>永久有效</span>
                    </el-col>
                </el-row>
                <el-row class="list-total" v-if="cardInfo.count_type !== '2'">
                    <el-col :span="6">合计</el-col>
                    <el-col :span="6" class="tc">&nbsp;</el-col>
                    <el-col :span="6" class="tc">{{totalNum}}次</el-col>
                    <el-col :span="6" class="tr">&nbsp;</el-col>
                </el-row>
            </div>
        </div>

    </PopForm>
</template>

<script>
    import obj from "@/js/obj";
    import TextInput from "@/model/TextInput";
    import PopForm from "@/model/PopForm";
    export default {
        name: "CardSaleHistoryProduct",
        components: {PopForm, TextInput},
        model: {
            prop: "state",
            event: "stateChange"
        },
        props: {
            state: Boolean,
            cardInfo: Object
        },
        data: () => ({
            listData: [],
            totalNum: 0,
            totalSurNum: 0,
            cardType: ""
        }),
        methods: {
            //初始化
            init: function () {
                this.getCardProduct();
            },
            //加载权益项目
            getCardProduct: function () {
                obj.postData("card/get_sale_history_product", {history_id: this.cardInfo.id}, res => {
                    if(res.errcode === 0){
                        this.listData = res.data;
                    }else{
                        obj.messageBox.error(res.errdesc);
                    }
                });
            },
            //关闭
            close: function () {
                this.$emit("stateChange", false);
            }
        },
        watch: {
            state: function (val) {
                if(val) this.init();
            },
            listData: function (data) {
                this.totalNum = 0;
                this.totalSurNum = 0;
                if(data){
                    let num = 0;
                    let surNum = 0;
                    data.forEach(val => {
                        num += Number(val.num);
                        surNum += Number(val.sur_num);
                    });
                    this.totalNum = num;
                    this.totalSurNum = surNum;
                }
            }
        }
    }
</script>

<style scoped>
    .form-body{
        padding: 0px 20px;
        height: 568px;
    }
    .form-body .text-desc{
        font-size: 14px;
        color: #333333;
        padding: 10px 0 20px;
    }
    .product-list{
        line-height: 40px;
    }
    .product-list .ht{
        height: 40px;
        line-height: 40px;
        background-color: #f4f4f4;
        padding: 0px 20px;
    }
    .product-list .list-line{
        border-bottom: 1px solid #ebedf0;
        padding: 0px 20px;
    }
    .product-list .list-total{
        padding: 0px 20px;
    }
</style>
